<template>
    <access-denied v-if="accessDenied" title="cliente" />
    <div v-else>
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        (!isUpdate && permissao.create) ||
                        (isUpdate && permissao.update)
                    "
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap mt-1">
                <div class="column is-full">
                    <div class="columns">
                        <div class="img-picker column is-3">
                            <ImgPicker
                                ref="imgPicker"
                                :logourl="cliente.logourl"
                                @uploadedFiles="getLogo"
                                @alert="showMessage"
                            />
                        </div>
                        <div class="column is-9">
                            <div class="columns is-flex-wrap">
                                <div class="cidade-input column is-4">
                                    <vss-select
                                        ref="cidadeInput"
                                        label="nome"
                                        title="cidade-do-promotor"
                                        :options="cidades"
                                        v-model="cidade"
                                        @search="loadCidade"
                                        :onChange="updateCidade()"
                                        placeholder="cidade-do-promotor-placeholder"
                                        :invalid="cidade == null"
                                        msg="msg-campo-obrigatorio"
                                        @onBlurFunction="
                                            validateIEInner();
                                            sendIsChanged('cidade');
                                        "
                                        :loading="loadingCidade"
                                        required
                                        searchable
                                    />
                                </div>
                                <div class="regiao-input column is-4">
                                    <vss-select
                                        ref="regiaoSelect"
                                        title="regiao"
                                        :options="regioes"
                                        v-model="regiao"
                                        @search="loadRegiao"
                                        @input="updateRegiao"
                                        placeholder="descricao-da-regiao-placeholder"
                                        :invalid="false"
                                        @onBlurFunction="
                                            sendIsChanged('regiao')
                                        "
                                    />
                                </div>
                                <div
                                    class="cnpj-input column is-4"
                                    :class="{ loading: isSearchingCNPJ }"
                                >
                                    <v-input
                                        :hideInfo="hide.hideInfo"
                                        :infoIsHidden="hide.infoIsHidden"
                                        v-model="cliente.cnpj"
                                        id="cnpj"
                                        title="cnpj-do-cliente"
                                        placeholder="cnpj-do-cliente-placeholder"
                                        :msg="invalidCNPJMsg"
                                        :invalid="invalidCNPJ"
                                        :onBlurFunction="validateCNPJInner()"
                                        ref="cnpjInput"
                                        v-mask="['##.###.###/####-##']"
                                        icon="magnify"
                                        @input-action="getInfoByCNPJ"
                                        required
                                    />
                                </div>
                                <div class="nome-input column is-6">
                                    <v-input
                                        v-model="cliente.nome"
                                        placeholder="nome-do-cliente-placeholder"
                                        :maxlength="100"
                                        title="nome-do-cliente"
                                        msg="msg-campo-obrigatorio"
                                        :invalid="!cliente.nome"
                                        ref="nomeInput"
                                        required
                                    />
                                </div>
                                <div class="razao-social-input column is-6">
                                    <v-input
                                        v-model="cliente.rsocial"
                                        placeholder="razao-social-placeholder"
                                        :maxlength="100"
                                        title="razao-social"
                                        :msg="'msg-campo-obrigatorio'"
                                        :invalid="!cliente.rsocial"
                                        ref="rsInput"
                                        required
                                    />
                                </div>
                                <div class="endereco-input column is-6">
                                    <v-input
                                        v-model="cliente.endereco"
                                        placeholder="endereço-do-cliente-placeholder"
                                        :maxlength="50"
                                        title="endereço-do-cliente"
                                        :msg="'msg-campo-obrigatorio'"
                                        :invalid="!cliente.endereco"
                                        ref="enderecoInput"
                                        required
                                    />
                                </div>
                                <div class="numero-input column is-2">
                                    <v-input
                                        id="numero"
                                        v-model="cliente.numero"
                                        :vMask="['##########']"
                                        placeholder="numero-cliente-placeholder"
                                        title="numero"
                                    />
                                </div>
                                <div class="cep-input column is-4">
                                    <v-input
                                        :hideInfo="hide.hideInfo"
                                        :infoIsHidden="hide.infoIsHidden"
                                        v-model="cliente.cep"
                                        id="cep"
                                        title="cep-do-cliente"
                                        placeholder="cep-do-cliente-placeholder"
                                        :msg="invalidCEPMsg"
                                        :invalid="invalidCEP"
                                        @onBlurFunction="
                                            validateCEPInner(),
                                                sendIsChanged('cep')
                                        "
                                        ref="cepInput"
                                        v-mask="['##.###-###']"
                                        required
                                    />
                                </div>
                                <div class="bairro-input column">
                                    <v-input
                                        v-model="cliente.bairro"
                                        placeholder="bairro-cliente-placeholder"
                                        :maxlength="50"
                                        title="bairro-cliente"
                                        msg="msg-campo-obrigatorio"
                                        :invalid="!cliente.bairro"
                                        ref="bairroInput"
                                        required
                                    />
                                </div>
                                <div class="inscricao-estadual-input column">
                                    <v-input
                                        :hideInfo="hide.hideInfo"
                                        :infoIsHidden="hide.infoIsHidden"
                                        v-model="cliente.ie"
                                        id="inscricao-estadual2"
                                        title="inscricao-estadual-do-cliente"
                                        placeholder="inscricao-estadual-do-cliente-placeholder"
                                        @onBlurFunction="
                                            validateIEInner();
                                            sendIsChanged('ie');
                                        "
                                        :invalid="invalidIE"
                                        :msg="invalidIEMsg"
                                        ref="ieInput"
                                        v-mask="['####################']"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="telefone-input column is-4">
                    <v-input-tel
                        ref="telefoneInput"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.telefone"
                        title="telefone-do-cliente"
                        :edit="checkEditTel(cliente.telefone)"
                        :msg="invalidTelefoneMsg"
                        :invalid="invalidTelefone"
                        :onBlurFunction="validateTelefone()"
                    />
                </div>
                <div class="celular-input column is-4">
                    <v-input-tel
                        ref="celularInput"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.celular"
                        title="celular-do-cliente"
                        :edit="checkEditTel(cliente.celular)"
                        :msg="invalidCelularMsg"
                        :invalid="invalidCelular"
                        icon="content-copy"
                        :onBlurFunction="validateCelular()"
                        @input-action="copyWhatsApp"
                    />
                </div>
                <div class="fax-input column is-4">
                    <v-input-tel
                        ref="faxInput"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.fax"
                        title="fax-do-cliente"
                        :edit="checkEditTel(cliente.fax)"
                        :msg="invalidFaxMsg"
                        :invalid="invalidFax"
                        :onBlurFunction="validateFax()"
                        v-if="!copyWhatsAppActive"
                    />
                </div>
                <div class="email-input column">
                    <v-input
                        v-model="cliente.email"
                        type="email"
                        placeholder="email-do-cliente-placeholder"
                        :maxlength="50"
                        title="email-do-cliente"
                        :msg="invalidEmailMsg"
                        :invalid="invalidEmail"
                        :onBlurFunction="validateEmailInner()"
                        ref="emailInput"
                    />
                </div>
                <div class="situacao-input2 column is-3">
                    <vss-select
                        title="situacao"
                        ref="situacaoSelect"
                        :options="situacoes"
                        :value="situacao"
                        @input="updateSituacao"
                        mlLabels
                        placeholder="situacao-da-marca-placeholder"
                        :disabled="
                            cliente.contratosinrotas > 0 && situacao.id == 1
                        "
                    />
                </div>
                <div class="facebook-input lower column is-full">
                    <v-input
                        ref="facebookInput"
                        v-model="cliente.facebook"
                        title="Facebook"
                        placeholder="Facebook"
                        icon="facebook-box"
                        type="text"
                        @input-action="openLink(cliente.facebook)"
                        disableMLtitle
                        disableMLplaceholder
                    />
                </div>
                <div class="linkedin-input lower column is-full">
                    <v-input
                        ref="linkedinInput"
                        v-model="cliente.linkedin"
                        title="Linkedin"
                        placeholder="Linkedin"
                        icon="linkedin-box"
                        type="text"
                        @input-action="openLink(cliente.linkedin)"
                        disableMLtitle
                        disableMLplaceholder
                    />
                </div>
                <div class="instagram-input lower column is-full">
                    <v-input
                        ref="instagramInput"
                        v-model="cliente.instagram"
                        title="Instagram"
                        placeholder="Instagram"
                        icon="instagram"
                        type="text"
                        @input-action="openLink(cliente.instagram)"
                        disableMLtitle
                        disableMLplaceholder
                    />
                </div>
                <div class="site-input lower column is-full">
                    <v-input
                        ref="siteInput"
                        v-model="cliente.site"
                        title="Site"
                        placeholder="Site"
                        icon="open-in-new"
                        type="text"
                        @input-action="openLink(cliente.site)"
                        disableMLtitle
                        disableMLplaceholder
                    />
                </div>
                <div class="obs-cadastral-input column is-half">
                    <label
                        for="obs-cadastral"
                        v-text="$t('obs-cadastral-do-cliente')"
                    />
                    <v-textarea
                        id="obs-cadastral"
                        v-model="cliente.obscadastral"
                        placeholder="obs-cadastral-do-cliente-placeholder"
                        :rows="6"
                    />
                </div>
                <div class="obs-financeira-input column is-half">
                    <label
                        for="obs-financeira"
                        v-text="$t('obs-financeira-do-cliente')"
                    />
                    <v-textarea
                        id="obs-financeira"
                        v-model="cliente.obsfinanceira"
                        placeholder="obs-financeira-do-cliente-placeholder"
                        :rows="6"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SelectBox from '@/components/shared/form/SelectBox.vue';
import ImgPicker from '@/components/shared/form/ImgPicker.vue';
import ClienteService from '@/services/promotor/ClienteService.js';
import CidadeService from '@/services/CidadeService.js';
import RegiaoService from '@/services/RegiaoService.js';
import ClienteValidation from '@/services/validations/promotor/cliente/ProClienteValidation.js';
import Message from '@/models/Message.js';
import * as InscricaoEstadual from '@/functions/IEValidation.js';
import HideInfo from '@/components/shared/HideInfo.vue';
import { mapState } from 'vuex';

export default {
    components: {
        SelectBox,
        ImgPicker,
        HideInfo,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            accessDenied: false,
            isSaving: false,
            service: new ClienteService(this.$http, this.$router),
            cidadeservice: new CidadeService(this.$http, this.$router),
            regiaoservice: new RegiaoService(this.$http, this.$router),
            validation: new ClienteValidation(),
            cliente: {
                id: null,
                situacao: 1,
                cidade: {
                    idcidade: null,
                    estado: null,
                    descricao: null,
                },
                cnpj: null,
                nome: null,
                rsocial: null,
                endereco: null,
                numero: null,
                cep: null,
                bairro: null,
                ie: null,
                telefone: null,
                celular: null,
                fax: null,
                email: null,
                facebook: null,
                linkedin: null,
                instagram: null,
                site: null,
                obscadastral: null,
                obsfinanceira: null,
                logourl: '',
            },
            logo: [],
            title: '',
            estado: {},
            estados: [],
            cidade: null,
            cidades: [],
            regiao: null,
            regioes: [],
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            isLoading: false,
            isSearchingCNPJ: false,
            invalidCNPJ: true,
            invalidCNPJMsg: 'msg-campo-obrigatorio',
            invalidEmail: false,
            invalidEmailMsg: 'msg-campo-obrigatorio',
            invalidCEP: true,
            invalidCEPMsg: 'msg-campo-obrigatorio',
            invalidIE: false,
            invalidIEMsg: 'msg-campo-obrigatorio',
            invalidTelefone: false,
            invalidTelefoneMsg: 'msg-campo-obrigatorio',
            invalidFax: false,
            invalidFaxMsg: 'msg-campo-obrigatorio',
            invalidCelular: false,
            invalidCelularMsg: 'msg-campo-obrigatorio',
            invalidCidade: false,
            canSelectCidade: false,
            canSelectRegiao: false,
            loadingCidade: false,
            copyWhatsAppActive: false,
            uf: null,
            isSearchingCEP: false,
            situacao: { label: 'ativo', id: 1 },
            situacoes: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            permissao: false,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'promotor',
            'cadastros',
            'clientes'
        );
        if (!this.permissao.read) {
            this.accessDenied = true;
            return;
        }
        if (this.isUpdate) {
            this.carregarDados();
        } else {
            setTimeout(() => {
                this.$emit('isChanged', false);
            }, 2500);
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    watch: {
        cliente: {
            deep: true,
            handler: function () {
                this.sendIsChanged('watch');
            },
        },
    },
    methods: {
        sendIsChanged(cameFrom = null) {
            // console.log('sendIsChanged', cameFrom);
            if (this.cliente.id == null && this.isUpdate)
                this.$emit('isChanged', false);
            if (!this.isLoadingEdit && !this.isLoading)
                this.$emit('isChanged', true);
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        showMessage(type, msg) {
            this.$root.msgs.push(new Message(type, msg, true));
        },
        validateCNPJInner() {
            if (!this.cliente.cnpj) {
                this.invalidCNPJ = true;
                this.invalidCNPJMsg = 'msg-campo-obrigatorio';
            } else if (
                this.cliente.cnpj &&
                !this.validateCnpj(this.cliente.cnpj)
            ) {
                this.invalidCNPJ = true;
                this.invalidCNPJMsg = 'msg-campo-invalido';
            } else {
                this.invalidCNPJ = false;
            }
        },
        validateEmailInner() {
            if (this.cliente.email && !this.validateEmail(this.cliente.email)) {
                this.invalidEmail = true;
                this.invalidEmailMsg = 'msg-campo-invalido';
            } else {
                this.invalidEmail = false;
            }
        },
        validateCEPInner() {
            if (!this.cliente.cep) {
                this.invalidCEP = true;
                this.invalidCEPMsg = 'msg-campo-obrigatorio';
            } else if (
                this.cliente.cep &&
                !this.validateCEP(this.cliente.cep)
            ) {
                this.invalidCEP = true;
                this.invalidCEPMsg = 'msg-campo-invalido';
            } else {
                this.invalidCEP = false;
            }
        },
        validateIEInner() {
            if (this.isNull(this.cidade) && !this.isNull(this.cliente.ie)) {
                /*
                    @85324 - É necessário que o estado (UF) seja reconhecido a partir da cidade para verificar a validade da inscrição estadual 
                    Não foi escolhido verificar o estado a partir da máscara, pois a máscara não é padronizada para diferentes estados
                */
                this.$root.msgs.push(
                    new Message(
                        'alert',
                        'msg-problema-preencher-cidade-cliente',
                        true
                    )
                );
            } else if (!this.isNull(this.cliente.ie)) {
                if (
                    !InscricaoEstadual.validateIE(
                        this.cliente.ie,
                        this.cidade.descricao
                    )
                ) {
                    this.invalidIE = true;
                    this.invalidIEMsg = 'msg-campo-invalido';
                } else {
                    this.invalidIE = false;
                }
            } else {
                this.invalidIE = false;
            }
        },
        validateTelefone() {
            if (
                !this.isNull(this.cliente.telefone) &&
                !this.validatePhone(this.cliente.telefone)
            ) {
                this.invalidTelefone = true;
                this.invalidTelefoneMsg = 'msg-campo-invalido';
            } else {
                this.invalidTelefone = false;
            }
        },
        validateFax() {
            if (
                !this.isNull(this.cliente.fax) &&
                !this.validatePhone(this.cliente.fax)
            ) {
                this.invalidFax = true;
                this.invalidFaxMsg = 'msg-campo-invalido';
            } else {
                this.invalidFax = false;
            }
        },
        validateCelular() {
            if (
                !this.isNull(this.cliente.celular) &&
                !this.validatePhone(this.cliente.celular)
            ) {
                this.invalidCelular = true;
                this.invalidCelularMsg = 'msg-campo-invalido';
            } else {
                this.invalidCelular = false;
            }
        },
        getSituacao() {
            return this.situacoes.filter(
                (s) => s.id == this.cliente.situacao
            )[0];
        },
        updateSituacao(situacao) {
            if (!this.isNull(situacao) && situacao.id != null) {
                this.cliente.situacao = situacao.id;
                this.situacao = situacao;
            }
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.$route.params.id)
                .then((body) => {
                    if (body.content.contratosinrotas > 0) {
                        this.hasVinculosAtivos = true;
                    }
                    this.title = this.cliente.name;
                    this.situacao = this.getSituacao();
                    this.cidade = {
                        id: body.content.cidade.idcidade,
                        estado: body.content.cidade.estado,
                        nome: body.content.cidade.descricao,
                    };
                    if (body.content.regiao) {
                        this.regiao = {
                            id: body.content.regiao.id,
                            obj: body.content.regiao,
                            label: body.content.regiao.descricao,
                        };
                    }
                    this.cliente.id = this.isNull(body.content.id)
                        ? null
                        : body.content.id;
                    this.cliente.situacao = body.content.situacao;
                    this.cliente.cidade.idcidade = this.isNull(
                        body.content.cidade.idcidade
                    )
                        ? null
                        : body.content.cidade.idcidade;
                    this.cliente.cidade.estado = this.isNull(
                        body.content.cidade.estado
                    )
                        ? null
                        : body.content.cidade.estado;
                    this.cliente.cidade.descricao = this.isNull(
                        body.content.cidade.descricao
                    )
                        ? null
                        : body.content.cidade.descricao;
                    this.cliente.cnpj = this.isNull(body.content.cnpj)
                        ? null
                        : body.content.cnpj;
                    this.cliente.nome = this.isNull(body.content.nome)
                        ? null
                        : body.content.nome;
                    this.cliente.rsocial = this.isNull(body.content.rsocial)
                        ? null
                        : body.content.rsocial;
                    this.cliente.endereco = this.isNull(body.content.endereco)
                        ? null
                        : body.content.endereco;
                    this.cliente.numero = this.isNull(body.content.numero)
                        ? null
                        : body.content.numero;
                    this.cliente.cep = this.isNull(body.content.cep)
                        ? null
                        : body.content.cep;
                    this.cliente.bairro = this.isNull(body.content.bairro)
                        ? null
                        : body.content.bairro;
                    this.cliente.ie = this.isNull(body.content.ie)
                        ? null
                        : body.content.ie;
                    this.cliente.telefone = this.isNull(body.content.telefone)
                        ? null
                        : body.content.telefone;
                    this.cliente.celular = this.isNull(body.content.celular)
                        ? null
                        : body.content.celular;
                    this.cliente.fax = this.isNull(body.content.fax)
                        ? null
                        : body.content.fax;
                    this.cliente.email = this.isNull(body.content.email)
                        ? null
                        : body.content.email;
                    this.cliente.facebook = this.isNull(body.content.facebook)
                        ? null
                        : body.content.facebook;
                    this.cliente.linkedin = this.isNull(body.content.linkedin)
                        ? null
                        : body.content.linkedin;
                    this.cliente.instagram = this.isNull(body.content.instagram)
                        ? null
                        : body.content.instagram;
                    this.cliente.site = this.isNull(body.content.site)
                        ? null
                        : body.content.site;
                    this.cliente.obscadastral = this.isNull(
                        body.content.obscadastral
                    )
                        ? null
                        : body.content.obscadastral;
                    this.cliente.obsfinanceira = this.isNull(
                        body.content.obsfinanceira
                    )
                        ? null
                        : body.content.obsfinanceira;
                    this.cliente.logourl = this.isNull(
                        body.content.logourl
                    )
                        ? null
                        : body.content.logourl;
                })
                .catch((e) => {
                    this.$root.msgs.push(
                        new Message('error', 'msg-erro-carregar-cliente', true)
                    );
                })
                .finally((_) => {
                    setTimeout(() => {
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    }, 2500);
                });
        },
        loadCidade(cidade = '', uf = null) {
            this.cidadeservice
                .findAll(0, 100, cidade)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.idcidade,
                            cidade: i.cidade,
                            nome: i.descricao,
                            descricao: i.estado.descricao,
                            estado: i.estado,
                        };
                    });
                })
                .then((allcidades) => {
                    this.cidades = Object.assign(allcidades);
                    this.cidades.sort();
                })
                .finally((_) => {
                    // foi colocado aqui para a busca com cep funcionar até com conexão fraca a internet
                    if (!this.isNull(this.buscaCep)) {
                        let idcidade = this.cidades.filter(
                            (s) => s.descricao == this.buscaCep.uf
                        );
                        if (idcidade.length > 0) {
                            this.loadCidadeById(idcidade[0].id);
                        } else {
                            this.$root.msgs.push(
                                new Message(
                                    'alert',
                                    'cidade-nao-encontrada',
                                    true
                                )
                            );
                        }
                        this.buscaCep = null;
                    } else if (uf != null) {
                        let idcidade = this.cidades.filter(
                            (s) => s.descricao == uf
                        );
                        if (idcidade.length > 0) {
                            this.loadCidadeById(idcidade[0].id);
                        }
                    }
                });
        },
        loadCidadeById(id) {
            this.cidadeservice
                .find(id)
                .then((cidade) => {
                    if (cidade.content != null) {
                        let temp = {
                            id: cidade.content.id,
                            nome: cidade.content.descricao,
                            descricao: cidade.content.estado.descricao,
                            estado: cidade.content.estado,
                            cidade: cidade.content.cidade,
                        };
                        this.cidade = temp;
                    } else {
                        console.warn('Busca de cidade vazia');
                    }
                }, 350)
                .finally((_) => {});
        },
        updateCidade() {
            if (this.cidade != null) {
                let cidadeTemp = this.cidades.filter(
                    (s) => s.id == this.cidade.id
                )[0];
                if (cidadeTemp != undefined) {
                    this.cliente.cidade.idcidade = cidadeTemp.id;
                }
            }
        },
        loadRegiao(value) {
            this.regiaoservice
                .findAllCombo(value ? value : '')
                .then(this.mapItems)
                .catch((e) => {
                    console.error('Erro ao carregar a regiao! ', e);
                    this.$root.msgs.push(
                        new Message('error', 'msg-erro-carregar-regiao', true)
                    );
                })
                .then((allregioes) => {
                    let reg = allregioes.filter(
                        (r) =>
                            this.regiao &&
                            r.obj.idregiao == this.regiao.obj.idregiao
                    )[0];
                    if (this.regiao && !reg) {
                        allregioes.push(this.regiao);
                    }
                    this.regioes = allregioes;
                    this.regioes.sort();
                    if (!this.isNull(this.regiao) && this.regiao.obj) {
                        this.updateRegiao(
                            this.regioes.filter(
                                (sg) =>
                                    sg.obj.idregiao == this.regiao.obj.idregiao
                            )[0]
                        );
                    }
                }, 350);
        },
        updateRegiao(regiao) {
            if (regiao) {
                this.regiao = regiao;
                this.cliente.regiao = regiao.obj;
            } else {
                this.cliente.regiao = null;
                this.regiao = null;
            }
            this.canSelectRegiao = false;
        },
        mapItems(body) {
            return body.content.map((i) => {
                return {
                    id: i.id,
                    obj: i,
                    label: i.descricao,
                };
            });
        },
        save() {
            this.isSaving = true;

            this.cliente.idcliente = this.cliente.id;

            this.cliente.cidade.idcidade =
                this.cidade == null ? null : this.cidade.id;
            this.cliente.cidade.estado =
                this.cidade == null ? null : this.cidade.estado;
            this.cliente.cidade.descricao =
                this.cidade == null ? null : this.cidade.nome;

            this.cliente = this.mapTosave(
                this.cliente,
                'cidade',
                'email',
                'datahorainc',
                'logourl',
                'facebook',
                'linkedin',
                'instagram',
                'site'
            );
            if (
                this.validation.validate(
                    this.$root,
                    this.cliente,
                    this.cidade,
                    this.$refs
                )
            ) {
                let file = null;
                if (this.logo && this.logo.length > 0 && this.logo[0]) {
                    file = this.logo[0].file;
                }
                this.service
                    .save(file, this.cliente)
                    .then((value) => {
                        if (value.message == null) {
                            let msg =
                                this.cliente.idcliente != null
                                    ? 'msg-edit-cliente'
                                    : 'msg-save-cliente';
                            this.$root.msgs.push(
                                new Message('success', msg, true)
                            );

                            setTimeout(() => {
                                this.$emit('isChanged', false);
                                if (!this.isUpdate)
                                    this.$router.push({
                                        name: 'clientes-edit',
                                        params: { id: value.content.id },
                                    });
                            }, 500);
                        } else {
                            if (this.$t(value.message)) {
                                this.$root.msgs.push(
                                    new Message('alert', value.message, true)
                                );
                            } else {
                                this.$root.msgs.push(
                                    new Message(
                                        'error',
                                        'msg-problema-realizar-acao',
                                        true
                                    )
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body.status == 409) {
                            this.$root.msgs.push(
                                new Message('alert', e.body.message, true)
                            );
                        } else {
                            console.error('Erro ao salvar: ' + e);
                            this.$root.msgs.push(
                                new Message('error', 'msg-erro-salvar', true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            } else {
                this.runValidations();
            }
        },
        getInfoByCNPJ() {
            this.validateCNPJInner();

            if (this.isNull(this.cidade)) {
                this.$root.msgs.push(
                    new Message('error', 'msg-erro-pesquisa-cnpj-cidade', true)
                );
            } else if (!this.invalidCNPJ) {
                let uf = this.cidade.descricao;
                let cnpj = this.cliente.cnpj;
                this.isSearchingCNPJ = true;
                this.service
                    .getInfoByCNPJ(uf, cnpj)
                    .then((res) => {
                        if (res.status != 200) {
                            if (res.status == 404) {
                                this.$root.msgs.push(
                                    new Message(
                                        'error',
                                        'msg-erro-cnpj-inexistente',
                                        true
                                    )
                                );
                            } else {
                                this.$root.msgs.push(
                                    new Message(
                                        'error',
                                        'msg-erro-pesquisa-cnpj',
                                        true
                                    )
                                );
                            }
                        } else {
                            let r = JSON.parse(res.content);
                            let data = null;
                            if (typeof r == 'object') {
                                r.forEach((e) => {
                                    if (e.situacao == '1') data = e;
                                });
                            } else if (r.length > 0) {
                                data = r[r.length - 1];
                            }
                            if (data != null) {
                                if (!this.isNull(data.fantasia)) {
                                    this.cliente.nome = data.fantasia;
                                }
                                this.cliente.rsocial = data.nome;
                                this.cliente.cep = data.cep;
                                this.cliente.endereco = data.logradouro;
                                this.cliente.numero = data.numero;
                                this.cliente.bairro = data.bairro;
                                if (this.isNull(this.cliente.ie))
                                    this.cliente.ie = data.ie;
                                this.validateCEPInner();
                            }
                        }
                    })
                    .catch((e) => {
                        this.$root.msgs.push(
                            new Message('error', 'msg-erro-pesquisa-cnpj', true)
                        );
                    })
                    .finally((_) => {
                        this.isSearchingCNPJ = false;
                        if (this.cliente.cep) this.getInfoByCEP();
                    });
            }
        },
        getInfoByCEP() {
            this.validateCEPInner();
            if (!this.invalidCEP) {
                let cep = this.cliente.cep;
                this.isSearchingCEP = true;
                let token = this.$moment().format('!%$MM(yyyy)DD*&');
                token = this.$CryptoJS.MD5(token).toString();

                this.service
                    .getInfoByCEP(cep, token)
                    .then((data) => {
                        this.buscaCep = data.content;
                        this.cliente.bairro = data.content.bairro;
                        this.cliente.endereco = data.content.logradouro;
                        this.loadCidade(
                            this.removeAcentos(data.content.cidade)
                        );
                    })
                    .catch((err) => {
                        this.$root.msgs.push(
                            new Message('error', 'msg-erro-pesquisa-cep', true)
                        );
                    })
                    .finally((_) => {
                        this.isSearchingCEP = false;
                    });
            }
        },
        getLogo(logo) {
            this.logo = logo;
            this.cliente.logourl = logo[0].imgurl;
            this.$forceUpdate();
        },
        runValidations() {
            this.validateCNPJInner();
            this.validateEmailInner();
            this.validateCEPInner();
            this.validateTelefone();
            this.validateFax();
            this.validateCelular();
            this.validateIEInner();
            this.isSaving = false;
        },
        copyWhatsApp() {
            this.copyWhatsAppActive = true;
            this.cliente.fax = this.cliente.celular;
            setTimeout(() => {
                this.copyWhatsAppActive = false;
                this.$forceUpdate();
            }, 100);
        },
        openLink(link) {
            if (!link.startsWith('http')) link = `http://${link}`;
            window.open(link.toLowerCase(), '_blank');
        },
        checkEditTel(val) {
            return (
                this.$route.params.id &&
                val != null &&
                val != '' &&
                val != ' ' &&
                val != undefined &&
                val != 'null'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.form {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    text-align: left;
    .img-picker {
        width: 20%;
        height: 250px;
    }
}
</style>
